import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './login.css'; // Optional for minor login-specific overrides
const API_URL = process.env.REACT_APP_API_URL;
const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    if (password !== confirmPassword) {
      setStatus({ error: 'Passwords do not match.' });
      return;
    }

    try {
      const res = await fetch('${API_URL}/api/password-reset-confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus({ success: 'Password successfully reset. You may now log in.' });
      } else {
        setStatus({ error: data?.error || 'Something went wrong.' });
      }
    } catch (err) {
      setStatus({ error: 'Server error. Please try again later.' });
    }finally {
        setSubmitLoading(false);
    }
  };

  return (
    <div className="step-questionnaire-container">
      <h1 className="top-header">Reset Your Password</h1>
      <div className="question-box">
      <img 
          src="images/firm-login-banner.png" 
          alt="Firm Login Banner" 
          className="login-banner-image" 
        />
        <form onSubmit={handleSubmit}>
          <div className="vertical-stack">
            <input
              type="password"
              placeholder="New Password"
              className="text-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Confirm New Password"
              className="text-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {status?.error && <div className="error-text mt-2">{status.error}</div>}
            {status?.success && (
                <div className="success-text mt-2">
                    {status.success} <a href="/login-firm">Return to Login</a>
                </div>
                )}
            <button type="submit" className="binary-button" disabled={submitLoading}>
                {submitLoading ? 'Resetting...' : 'Reset Password'}
                </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;